export default __webpack_public_path__ + "static/media/portfolio-46.529c73b2.jpg";